




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {executeQuery} from '@/data/repos/query'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import config from "@/config"

function linkCallBack(fieldName: string, row: any) {
  return {
    url: config.IPR_BASE_URL + '/pages/locationjumper.asp?id=' + encodeURIComponent(row.id),
    text: row.value,
  }
}

@Component({
  components: {
    DataGrid,
  },
})
export default class LocationCountDrillDown extends Vue {
  @Prop() public args!: { locationType: string }
  public tableData: object[] = []
  public fields = [
    {name: 'value', title: 'Name', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: linkCallBack},
    {name: 'nua', title: 'Nua', dataType: DataType.Number, sort: 1},
    {name: 'gia', title: 'Gia', dataType: DataType.Number, sort: 1},
  ]

  public async getData(offset = 0, limit = 500) {
    const data = await executeQuery('idr', 'locationDrillDown', {locationId: 10, locationType: this.args.locationType}, undefined, offset, limit)
    if (!data) {
      return null
    }
    return data.map((row) => {
      return {
        // link: {component: link},
        id: row.Value,
        value: row.Label,
        nua: row.nua,
        gia: row.gia,
      }
    })
  }
}
